import styled from 'styled-components';

import Icon from '@ant-design/icons';

export const Container = styled.button(({ theme }) => ({
  cursor: 'pointer',
  width: '127rem',
  height: '127rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  opacity: 1,
  border: 'none',
  backgroundColor: 'transparent',
  alignItems: 'center',

  '& svg': {
    fill: theme.palette.darkLiver,
  },

  '&:hover': {
    color: theme.palette.artichoke,
  },

  '&:hover svg': {
    fill: theme.palette.artichoke,
  },
}));

export const ShapeImage = styled(Icon)(({ theme }) => ({
  '&[data-is-selected="true"]': {
    border: `4rem solid ${theme.defaultTheme.secondaryColor}`,
    borderRadius: '8rem',
  },
}));

export const ShapeTitle = styled.div({
  fontWeight: 'bolder',
  textAlign: 'center',
  minHeight: '40rem',
  fontSize: '10rem',
});
